import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Paper,
} from '@mui/material';
import {
  VerifiedUser as CertificateIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  PendingActions as PendingIcon,
} from '@mui/icons-material';

const Dashboard = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, color: '#00024c', mb: 3 }}>
        Certificate Cell Dashboard
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderLeft: '4px solid #1976d2' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <CertificateIcon sx={{ color: '#1976d2', fontSize: 40 }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>Certificates</Typography>
                  <Typography variant="body2" color="text.secondary">Total Issued</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderLeft: '4px solid #388e3c' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <CheckCircleIcon sx={{ color: '#388e3c', fontSize: 40 }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>Approved</Typography>
                  <Typography variant="body2" color="text.secondary">Ready to Issue</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderLeft: '4px solid #f57c00' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <PendingIcon sx={{ color: '#f57c00', fontSize: 40 }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>Pending</Typography>
                  <Typography variant="body2" color="text.secondary">Awaiting Action</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderLeft: '4px solid #7b1fa2' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <AssignmentIcon sx={{ color: '#7b1fa2', fontSize: 40 }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>Applications</Typography>
                  <Typography variant="body2" color="text.secondary">Under Review</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Paper sx={{ mt: 4, p: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#00024c' }}>
          Welcome to Certificate Cell
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Use the sidebar to navigate to specific sections. You can view and manage certificates,
          track application statuses, and perform certificate-related operations.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Dashboard;
